import About from "./pages/about";
import Contact from "./pages/contact";
import Downloads from "./pages/downloads";
import Home from "./pages/home";
import Projects from "./pages/projects";
import Resume from "./pages/resume";

export const routes = [
  {
    path: "/",
    label: "Home",
    element: <Home />,
    showInNavigation: false,
    metadata: {
      title: "CS Development",
      description:
        "Cory Smith is a full stack developer building responsive web applications, APIs, and user-focused software solutions.",
    },
  },
  {
    path: "/about",
    label: "About",
    element: <About />,
    showInNavigation: true,
    metadata: {
      title: "About Cory Smith",
      description:
        "Learn about Cory Smith's background, full stack development skills, experience, education, and technical interests.",
    },
  },
  {
    path: "/projects",
    label: "Projects",
    element: <Projects />,
    showInNavigation: true,
  },
  {
    path: "/downloads",
    label: "Downloads",
    element: <Downloads />,
    showInNavigation: false,
    showInFooter: false,
    standalone: true,
    metadata: {
      title: "No Bull Lifting — Android & Wear OS Downloads",
      exactTitle: true,
      siteName: "No Bull Lifting",
      description:
        "Download the latest No Bull Lifting Android phone and Wear OS apps by Cory Smith.",
    },
  },
  {
    path: "/resume",
    label: "Resume",
    element: <Resume />,
    showInNavigation: true,
    metadata: {
      title: "Resume",
      description:
        "View and download Cory Smith's resume, including full stack development experience, skills, education, and achievements.",
    },
  },
  {
    path: "/contact",
    label: "Contact",
    element: <Contact />,
    showInNavigation: true,
    metadata: {
      title: "Contact Cory Smith",
      description:
        "Contact Cory Smith to discuss web application development, API development, responsive design, or software consulting.",
    },
  },
];

export const navigationRoutes = routes.filter((route) => route.showInNavigation);
